<template>
    <div class="login-main" :style="'background-image:url('+ loginBg +')'">
        <div class="content">
            <div class="wrapper">
                <div class="img"><img :src="img_path" /></div>
                <div class="content-login">
                    <div class="title">欢迎登录</div>
                    <div class="content-info">
                        <el-form ref="form" :model="form" :rules="rules">
                            <el-form-item prop="account">
                                <el-input v-model="form.account" placeholder="请输入账号"  @keyup.enter.native="keyupEvent"></el-input>
                                <svg class="icon">
                                    <use xlink:href="#icon-account"></use>
                                </svg>
                            </el-form-item>
                            <el-form-item class="pwd-item" prop="password">
                                <el-input v-model="form.password" placeholder="请输入密码" :type="typePwd"  @keyup.enter.native="keyupEvent">
                                    <i slot="suffix" :class="'iconfont ' + icon" @click="showPwd"></i>
                                </el-input>
                                <svg class="icon">
                                    <use xlink:href="#icon-password"></use>
                                </svg>
                            </el-form-item>

                           <el-form-item class="phone-item" prop="verificationPhoneCode">
                                <el-input class="input-code left" v-model="form.verificationPhoneCode" @keyup.enter.native="keyupEvent" placeholder="请输入验证码" ></el-input>
                                <svg class="icon">
                                    <use xlink:href="#icon-password"></use>
                                </svg>
                                <div class="btn-identify">
                                    <img ref="imgCode" :src="identifyCode.identifyCodeBase64" class="img-code" @click="changeVerifyCode" alt="验证码" title="点击换一张">
                                </div>
                            </el-form-item>
                            <el-form-item class="btn-item">
                                <el-button type="primary" round @click="clickLogin()">立即登录</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
                <div style="margin-top: 10px;  color: #fff; font-size: 14px; text-align: center;">建议使用Chrome浏览器登录本系统...</div>
            </div>
        </div>
    </div>
</template>
<script>
import codeBg from '@/assets/images/code.png'
import loginBg from '@/assets/images/login-bg.png'
// eslint-disable-next-line camelcase
import ll_login from '@/assets/images/logo-03.png'
import zzlogin from '@/assets/images/login-logo.png'
import czlogin from '@/assets/images/后台-logo1.png'
import {loginApi} from '@/api/loginApi'
import { Notification } from 'element-ui'
export default {
  name: 'login',
  data() {
    return {
      identifyCode: {}, // 验证码路径
      codeBg,
      loginBg,
      typePwd: 'password', // 密码框初始类型为密码框
      icon: ' icon-buxianshi', // 闭眼图标
      disabled: false,
      totalCount: 0, // 多少秒后可点击
      form: {
        verificationPhoneCodeUUID: ''
      },
      time: '',
      sendTimer: null,
      timer: '',
      rules: {
        account: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        phone: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { validator: this.$validRule.checkMobile, trigger: 'blur' }
        ],
        verificationPhoneCode: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ]
      },
      word: '发送验证码',
      isOvertime: false,
      identifyCode_st: '', // 系统生成的验证码
      img_path: require('@/assets/images/logo-03.png')
    }
  },
  created() {
    for (let i = 0; i < city.length; i++) {
      if (city[i].check === true) {
        const cityName = city[i].cityname
        if (cityName === '醴陵市') {
          // eslint-disable-next-line camelcase
          this.img_path = ll_login
        } else if (cityName === '株洲市') {
          this.img_path = zzlogin
        } else if (cityName === '郴州市') {
          this.img_path = czlogin
        }
      }
    }
    this.timer = setInterval(() => {
      this.time = this.$utils.dateFormat(new Date(), 'yyyy年MM月dd日 HH时mm分ss秒')
    }, 100)
  },
  mounted() {
    this.changeVerifyCode()
  },
  methods: {
    // 点击图片修改图片src
    changeVerifyCode() {
      const _this = this
      if (_this.getCodeTimer) {
        clearInterval(_this.getCodeTimer)
      }
      loginApi.getVerifyCodeImg().then(res => {
        _this.identifyCode = res
        _this.identifyCode_st = res.identifyCode// 获取系统生成的验证码
        _this.form.verificationCodeUUID = res.verificationCodeUUID
        _this.getCodeTimer = setInterval(() => {
          _this.changeVerifyCode()
        }, 1000 * 60 * 3)
      })
    },
    // 点击小眼睛显示密码
    showPwd() {
      if (this.typePwd === 'text') {
        this.typePwd = 'password'
        // 更换图标
        this.icon = ' icon-buxianshi'
      } else {
        this.typePwd = 'text'
        this.icon = ' icon-xianshi'
      }
    },
    currentTime() {
      setInterval(this.time, 1000)
    },
    keyupEvent(e) {
      e = window.event || e
      if (this.$route.path === '/login' && (e.code === 'Enter' || e.code === 'enter' || e.keyCode === 13)) { // 验证在登录界面和按得键是回车键enter
        this.clickLogin()
      }
    },
    // 登录
    clickLogin () {
      this.$refs.form.validate(valid => {
        if (valid) {
          const params = {
            account: this.form.account,
            password: this.form.password,
            verificationCode: this.form.verificationPhoneCode, // 用户输入的验证码
            verificationCodeUUID: this.form.verificationCodeUUID
          }
          const _this = this
          loginApi.loginValidByAccount(params).then(response => {
            if (response.code === '200' && response.msg === 'ok') {
              const userInfo = {}
              userInfo.token = response.data.token
              userInfo.userId = response.data.userId
              userInfo.userName = response.data.userName
              userInfo.userAccount = response.data.userAccount
              userInfo.registerType = response.data.registerType
              userInfo.userAddress = response.data.userAddress
              this.$store.commit('login', userInfo)
              this.$store.commit('setUserInfo', userInfo)
              this.$router.push({
                name: 'system'
              })
            } else if (response.code !== '200') {
              this.changeVerifyCode()
              Notification.warning({
                title: '警告',
                message: response.msg,
                type: 'warning'
              })
            }
          })
        }
      }
      )
    },
    getCode () {
      if (this.sendTimer) {
        clearInterval(this.sendTimer)
      }
      let isSendMessage = false
      this.$refs.form.validateField('phone', errorMessage => {
        isSendMessage = !!errorMessage
      })
      if (!isSendMessage) {
        // const params = {
        //   phone: this.form.phone,
        //   phoneType: 'LG'
        // }
        // this.isOvertime = true
        // GetIdentifyCode(params).then(res => {
        //   if (res.code == 200) {
        //     let time = 60
        //     this.sendTimer = setInterval(() => {
        //       this.isOvertime = true
        //       time--
        //       this.word = time + 's'
        //       if (time <= 0) {
        //         this.isOvertime = false
        //         clearInterval(this.sendTimer)
        //         this.word = '获取验证码'
        //       }
        //     }, 1000)
        //     this.form.verificationPhoneCodeUUID = res.data.verificationPhoneCodeUUID
        //     this.utils.success('短信验证码发送成功！')
        //   } else {
        //     this.isOvertime = false
        //     this.utils.error(res.msg)
        //   }
        // })
      }
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer) // 在Vue实例销毁前，清除我们的定时器
    }
    if (this.sendTimer) {
      clearInterval(this.sendTimer)
    }
  }
}
</script>
<style lang="scss" scoped>
    .login-main{
        width: 100%;
        background-size: 100% 100%;
        min-height: 100vh;
        background-position: center bottom;
        background-repeat: no-repeat;
        .header{
            display: flex;
            justify-content: space-between;
            height: 56px;
            line-height: 56px;
            opacity: 1;
            background: rgba(39,137,238,0.20);
            box-shadow: 0px 4px 4px 0px rgba(7,45,84,0.20);
            color: #ffffff;
            font-size: 16px;
            .header-left{
                padding-left: 130px;
            }
            .header-right{
                padding-right: 130px;
                cursor: pointer;
                .iconfont{
                    margin-right: 8px;
                }
            }
        }
        .content{
            display: flex;
            height: calc(100vh - 56px);
            align-items: center;
            .wrapper{
                width: 1200px;
                margin: 0 auto;
                margin-top: 50px;
                .img{
                    text-align: center;
                    margin-bottom: 29px;
                    img{
                        width: 908px;
                    }
                }
                .content-login {
                    width: 560px;
                    height: 440px;
                    background: #ffffff;
                    margin:  0 auto;
                    border-radius: 8px;
                    box-shadow: 0px 4px 4px 0px rgba(0,0,0,0.25);
                    .title{
                        text-align: center;
                        line-height: 106px;
                        height: 106px;
                        font-size: 32px;
                        color: #2789ee;
                    }
                    /deep/ .content-info{
                        padding:0px 64px 0px 64px ;
                        .el-form-item {
                            position: relative;
                            .el-input__inner {
                                height: 50px;
                                font-size: 16px;
                                padding: 0 50px;
                            }
                            .icon {
                                position: absolute;
                                top: 13px;
                                left: 15px;
                                width: 20px;
                                height: 20px;
                                fill: currentColor;
                                overflow: hidden;
                            }
                            .el-input__prefix, .el-input__suffix {
                                color: #E4E4E4;
                            }
                            .el-input__prefix {
                                left: 15px;
                                i {
                                    font-size: 20px;
                                    line-height: 50px;
                                }
                            }
                            .input-code {
                                width: 303px;
                            }
                        }
                        .pwd-item {
                            .el-input__suffix {
                                color: #666;
                                right: 20px;
                                top: 5px;
                                cursor: pointer;
                            }
                        }
                        .code-item ,.phone-item {
                            margin-bottom: 5px;
                            .img-identify, .btn-identify {
                                float: right;
                                height: 48px;
                                line-height: 19px;
                                width: 110px;
                                border: 1px solid #DCDFE6;
                                border-radius: 4px;
                                .img-code {
                                    height: 48px;
                                    width: 111px;
                                }
                            }
                            .img-identify {
                                border: 0;
                            }
                        }
                        .phone-item {
                            margin-bottom: 22px;
                            .btn-identify {
                                display: inline-block;
                                height: 49px;
                                border: none;
                                .el-button {
                                    height: 49px;
                                    width: 110px;
                                    padding: 0;
                                    background-color: #E8F4FF;
                                    color: #2789EE;
                                    border: none;
                                    &:hover {
                                        background-color: #409EFF;
                                        color: #fff;
                                    }
                                    &.is-disabled, &.is-disabled:hover {
                                        background-color: #ecf5ff;
                                        color: #8cc5ff;
                                        border: none;
                                    }
                                }
                            }
                        }
                        .small-text {
                            margin-bottom: 10px;
                            .small-btn {
                                display: flex;
                                justify-content: space-between;
                            }
                        }
                        .btn-item {
                            margin-top: 30px;
                            .el-button {
                                width: 100%;
                                height: 45px;
                                font-size: 16px;
                                border: none;

                            }
                        }
                    }
                }
            }
        }
    }
    @media (max-width: 1366px){
        .login-main .header {
            height: 40px;
            line-height: 40px;
        }
        .login-main .content .wrapper {
            margin-top: 20px;
        }
        .login-main .content .wrapper .img {
            margin-bottom: 0;
        }
        .login-main .content .wrapper .content-login {
            height: 445px;
        }
        .login-main .content .wrapper .content-login .title {
            height: 80px;
            line-height: 80px;
            font-size: 24px;
        }
    }
</style>
